import script from "./StepBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepBox.vue?vue&type=script&setup=true&lang=ts"

import "./StepBox.vue?vue&type=style&index=0&id=4a4e594a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4e594a"]])

export default __exports__